import { generateAppRoute } from '@/shared/util';

export function generateReportingRoute(studyId: string, key: string) {
  switch (key) {
    case 'final_impressions':
      return generateAppRoute('FINAL_IMPRESSIONS', { params: { studyId } });
    case 'key_images':
      return generateAppRoute('KEY_IMAGES', { params: { studyId } });
    case 'preview':
      return generateAppRoute('PREVIEW', { params: { studyId } });
    case 'quality_review':
      return generateAppRoute('QUALITY_REVIEW', { params: { studyId } });
    case 'reason_for_scan':
      return generateAppRoute('REASON_FOR_SCAN', { params: { studyId } });
    case 'ai_findings':
      return generateAppRoute('AI_FINDINGS', { params: { studyId } });
    default:
      return generateAppRoute('ORGAN', { params: { organ: key.replace(/_/g, '-'), studyId } });
  }
}
